<div class="box">
    <div class="body">
        <div class="rebote">
            <img src="/icons/sofa.png" alt="404">
        </div>
        <div class="message-box">
            <h1 id="fourofour">404</h1>
            <h1>Page not found</h1>
            <div class="buttons-con">
                <div class="action-link-wrap">
                    <a href="/" class="link-button">VOLVER A LA HOME</a>
                </div>
            </div>
        </div>
    </div>
</div>


<style>
    .body {
        background-color: #f2f2f266;
        display: inline-flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
        gap: 10%;
        padding: 5%;

    }

    .box {
        height: 100%;
        width: 100%;
        display: flex;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: var(--theme-color-4);
    }

    #fourofour {
        font-size: 140px;

    }

    .message-box {
        color: #FFF;
        font-family: Roboto;
        font-weight: 300;
    }

    .message-box h1 {
        font-size: 60px;
        line-height: 46px;
        margin-bottom: 40px;
    }

    .buttons-con .action-link-wrap {
        margin-top: 40px;
    }

    .buttons-con .action-link-wrap a {
        background: var(--theme-color-1);
        padding: 18px 25px;
        border-radius: 5px;
        color: #FFF;
        font-weight: bold;
        font-size: 14px;
        transition: all 0.3s linear;
        cursor: pointer;
        text-decoration: none;
        margin-right: 10px;
        min-width: 150px;
    }

    .buttons-con .action-link-wrap a:hover {
        background: #5A5C6C;
        color: #fff;
    }


    @media (max-width: 450px) {

        .message-box {
            text-align: center;
            margin-bottom: 50px;
        }
    }


    .rebote img {
        width: 400px;
        height: 400px;
        margin-left: 50px;
        margin-top: 100px;
        position: relative;
        -webkit-animation-name: rebote;
        /* Chrome, Safari, Opera */
        -webkit-animation-duration: 5s;
        /* Chrome, Safari, Opera */
        -webkit-animation-iteration-count: infinite;
        /* Chrome, Safari, Opera */
        -webkit-animation-direction: reverse;
        /* Chrome, Safari, Opera */
        animation-name: rebote;
        animation-duration: 5s;
        animation-iteration-count: infinite;
        animation-direction: reverse;
        animation-timing-function: ease-out;
    }

    /* Standard syntax */
    @keyframes rebote {
        0% {
            left: 0px;
            top: 0px;
        }

        25% {
            left: 0px;
            top: 0px;
        }

        50% {
            left: 0px;
            top: -100px;
        }

        75% {
            left: 0px;
            top: -100px;
        }

        100% {
            left: 0px;
            top: 0px;
        }
    }

    @media (max-width: 994px) {

        .body {
            background-color: #f2f2f266;
            display: inline-flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: center;
            align-items: center;
            gap: 5%;
            padding: 5%;
            flex-flow: wrap-reverse;
        }
    }

    @media (max-width: 768px) {

        .box {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            flex-wrap: nowrap;
            padding: 20px 0;
            ;
            padding: 20px 0;
        }

        .body {
            background-color: var(--theme-color-4);

        }

        .rebote img {
            width: 80%;
            height: auto;
            margin-left: 0;
            margin-top: 110px;
        }

        .message-box h1 {
            font-size: 60px;
            line-height: 82px;
            margin: 0px;
        }

    }
</style>